import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Tooltip } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

import { Job } from "Models/job";
import { getOrderCustomerDisplayName } from "Util/names";
import { AppBadgeStyle, AppBadgeTitle, WrapperBadge } from "./styles";

interface DrawerHeaderProps {
  order: Partial<Job>;
}

export function DrawerHeader(props: DrawerHeaderProps) {
  const { order } = props;
  const { t: translate } = useTranslation();

  return (
    <Grid container alignItems="center" justifyContent="space-between" direction="row" spacing={2}>
      <Grid item container xs={12} md={8} alignItems="center" justifyContent="flex-end">
        <Grid item xs={12} md={6}>
          <WrapperBadge>
            <AppBadgeTitle>{translate("reference")}:</AppBadgeTitle>
            <AppBadgeStyle backgroundColor={colors.brandBlue50} color={colors.brandBlue600}>
              <Tooltip title={order.reference!} placement="top">
                <span>{order.reference!}</span>
              </Tooltip>
            </AppBadgeStyle>
          </WrapperBadge>
        </Grid>
        <Grid item xs={12} md={6}>
          <WrapperBadge isAlignEnd={true}>
            <AppBadgeTitle>{translate("customer")}:</AppBadgeTitle>
            <AppBadgeStyle backgroundColor={colors.brandBlue50} color={colors.brandBlue600}>
              <Tooltip title={getOrderCustomerDisplayName(order)} placement="top">
                <span>{getOrderCustomerDisplayName(order)}</span>
              </Tooltip>
            </AppBadgeStyle>
          </WrapperBadge>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4} alignItems="center" justifyContent="flex-end">
        <WrapperBadge isAlignEnd={true}>
          <AppBadgeTitle>{translate("type")}:</AppBadgeTitle>
          <AppBadgeStyle backgroundColor={colors.brandBlue50} color={colors.brandBlue600}>
            <Tooltip title={order.type!} placement="top">
              <span>{order.type || ""}</span>
            </Tooltip>
          </AppBadgeStyle>
        </WrapperBadge>
      </Grid>
    </Grid>
  );
}
